
import ProductImageGalleryRightNav from "./productImageGalleryRightNav";
import {mockProducts} from "../../../pages/products/mock/mockProducts";


export default function ProductImageGallery({ images = [],currentIndex,setActiveImage }) {
  return (
      <>
        <ProductImageGalleryRightNav
            images={images}
            currentIndex={currentIndex}
            onPrev={() => setActiveImage(i => Math.max(0, i - 1))}
            onNext={() => setActiveImage(i => Math.min(images.length - 1, i + 1))}
        />
      </>

  );
}

